import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import reducer from './reducers/authentication.reducer';
import { userConstants } from './constants';

const loggerMiddleware = createLogger({
    predicate: (getState, action) => {
        // Escludere dal logging le azioni di login/logout
        const excludedActions = [
            userConstants.LOGIN_REQUEST,
            userConstants.LOGIN_SUCCESS,
            userConstants.LOGIN_FAILURE,
            userConstants.LOGOUT
        ];
        return !excludedActions.includes(action.type);
    }
});

export const store = createStore(
    reducer,
    applyMiddleware(
        thunkMiddleware,
        loggerMiddleware
    )
);